import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth, formatApiErrorDetail } from "../lib/auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (user && user.role) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
        background: "var(--fs-onyx)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "440px",
          border: "1px solid var(--fs-line-strong)",
          background: "var(--fs-onyx-2)",
          padding: "3rem 2.5rem",
        }}
      >
        <a
          href="/"
          className="fs-overline"
          style={{ color: "var(--fs-bone-3)", marginBottom: "1.5rem", display: "inline-block" }}
          data-testid="admin-login-back-home"
        >
          ← Back to site
        </a>
        <h1 className="fs-display-3" style={{ marginBottom: "0.6rem" }}>
          Friends Salon&nbsp;<span className="fs-ital">24</span>
        </h1>
        <p className="fs-overline" style={{ color: "var(--fs-muted)", marginBottom: "2rem" }}>
          Atelier · Admin Console
        </p>

        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="fs-label" htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              required
              autoComplete="email"
              className="fs-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="fs-label" htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              required
              autoComplete="current-password"
              className="fs-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <p
              data-testid="admin-login-error"
              style={{ color: "#E07B7B", fontSize: "0.85rem", letterSpacing: "0.05em" }}
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={busy}
            className="fs-btn-primary"
            style={{ width: "100%", justifyContent: "center", marginTop: "0.5rem" }}
            data-testid="admin-login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
